/**
 * Peças da criação de senha, as mesmas no primeiro acesso (troca da
 * provisória) e no convite por e-mail: campo com olho, medidor de força e
 * checklist. Sem `provisoria`, o checklist não mostra "Diferente da
 * provisória" (ver requisitosDaSenha).
 */
import React, { useState } from "react";

import { ROTULOS_DE_FORCA, forcaDaSenha, requisitosDaSenha } from "./regrasDaSenha";
import { IconeCadeado, IconeOlho, IconeOlhoRiscado } from "./icones";

export function CampoDeSenha({ id, rotulo, autoComplete, placeholder, nomeDoOlho, valor, aoMudar, invalido, descritoPor, somenteLeitura, autoFocus, children }) {
  const [visivel, setVisivel] = useState(false);
  return (
    <div className="f">
      <label className="f-l" htmlFor={id}>{rotulo}</label>
      <div className={`f-box${invalido ? " bad" : ""}`}>
        <IconeCadeado />
        <input
          id={id}
          type={visivel ? "text" : "password"}
          autoComplete={autoComplete}
          placeholder={placeholder}
          value={valor}
          readOnly={somenteLeitura}
          autoFocus={autoFocus}
          onChange={(e) => aoMudar(e.target.value)}
          aria-invalid={invalido || undefined}
          aria-describedby={descritoPor || undefined}
        />
        <button
          className="eye"
          type="button"
          aria-label={`${visivel ? "Ocultar" : "Mostrar"} ${nomeDoOlho}`}
          aria-pressed={visivel}
          onClick={() => setVisivel((v) => !v)}
        >
          {visivel ? <IconeOlhoRiscado /> : <IconeOlho />}
        </button>
      </div>
      {children}
    </div>
  );
}

export function MedidorDeForca({ senha }) {
  const nivel = forcaDaSenha(senha);
  // aria-hidden: o checklist logo abaixo já diz o que falta.
  return (
    <div className="meter" aria-hidden="true">
      <div className={`bars l${nivel}`}>
        <span />
        <span />
        <span />
        <span />
      </div>
      <span className="meter-l">{ROTULOS_DE_FORCA[nivel]}</span>
    </div>
  );
}

export function Requisitos({ id, nova, provisoria }) {
  return (
    <ul className="rqs" id={id} aria-label="Requisitos da senha">
      {requisitosDaSenha(nova, provisoria).map((r) => (
        <li key={r.id} className={`rq${r.cumprido ? " ok" : ""}`}>
          {r.texto}
          {/* O check verde é só visual (::before); o leitor de tela ouve isto. */}
          <span className="sr">{r.cumprido ? " — cumprido" : " — pendente"}</span>
        </li>
      ))}
    </ul>
  );
}
